// AnimatedSvg.ts
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";

import gsap from "gsap";
import { useMouseStore } from "../../store";

class AnimatedSvg extends MainClass {
	constructor(options: MAIN_CLASS_PARAMS) {
		super(options);
		this.init();
	}

	handleMouseMove(e: MouseEvent, ellipseEl: SVGElement) {
		const { innerWidth, innerHeight } = window;
		const xRatio = e.clientX / innerWidth;
		const yRatio = e.clientY / innerHeight;

		// 1) Update state in store
		(useMouseStore as any).getState().setMouse(xRatio, yRatio);

		// 2) Calculate coordinates and animate with GSAP
		const offsetX = (xRatio - 0.5) * 200;
		const offsetY = (yRatio - 0.5) * 200;
		const rx = 300 + (xRatio - 0.5) * 70;
		const ry = 200 + (yRatio - 0.5) * 100;

		gsap.to(ellipseEl, {
			duration: 0.5,
			attr: {
				cx: 960 + offsetX,
				cy: 540 + offsetY,
				rx,
				ry,
			},
			ease: "power2.out",
		});
	}

	init() {
		console.log("a:", this.selector);
		const ellipseEl = this.selector.querySelector(
			'ellipse[data-ellipse="true"]',
		) as SVGElement;
		if (ellipseEl) {
			window.addEventListener("mousemove", (e) => {
				this.handleMouseMove(e, ellipseEl);
			});
		}

		useMouseStore.subscribe((newState, oldState) => {
			console.log("Mouse ratio changed:", newState.xRatio, newState.yRatio);
		});
	}
}

export default AnimatedSvg;
